import React, { Component } from 'react';
import { getIcon, isEmpty } from '../Common/Common';
// import { Swipeable } from 'react-swipeable';

import dashboard_icon from '../../Images/Daikin_Images/image/Dashboard.png';
import group_icon from '../../Images/Daikin_Images/image/Group.png';
import layout_icon from '../../Images/Daikin_Images/image/Layout.png';
import scene_icon from '../../Images/Daikin_Images/image/Scene.png';
import report_icon from '../../Images/Daikin_Images/image/Data.png';
import system_icon from '../../Images/Daikin_Images/image/System.png';
import ipcam_icon from '../../Images/Daikin_Images/image/Ipcam.png';
import guest_room_icon from '../../Images/Daikin_Images/image/GRmanage.png';
import rt_energy_view_icon from '../../Images/Daikin_Images/image/RTMLayout.png';
import iaq_monitoring_icon from '../../Images/Daikin_Images/image/IAQmonitoring.png';

import {
    navigateLayout, navigateRTEnergy, navigateIAQMonitoring, navigateDashboard, navigateGroups, navigateScenes, navigateReport, navigateSystem,
    navigateGuestRoom
} from '../Common/navigation';

import string_table from '../../Interface/StringTable.js';
import Popup from '../Part_Sample/Popup.js';

export default class Bottom_Menu_Bar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tag: 'Dashboard',
            is_dashboard_active: true,
            is_group_active: false,
            is_scenes_active: false,
            is_report_active: false,
            is_system_active: false,
            is_ipcam_active: false,
            is_layout_active: false,
            is_guest_room_active: false,
            is_rt_energy_active: false,
            is_iaq_mon_active: false,
            show_popup: false,
            should_show_popup: false
        }

        this.indexToAdd = 0;
    }

    handleUniview = () => {
        window.app.showLoading();
        // console.log("Uniview retrieve updated cameras now")
        let controller_info = {};
        if (this.props.receiver.active_controller != null) {
            // When app first started, active_controller is null, app will crash if we try to get the name
            controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
        }

        let controller_mac_addr = controller_info.mac_addr;
        let controller_username = controller_info.username;

        let uniview_info = JSON.parse(window.localStorage.getItem('uniview_info'));
        let username = uniview_info[controller_mac_addr][controller_username].username;
        let password = uniview_info[controller_mac_addr][controller_username].password;
        let num_screen = uniview_info[controller_mac_addr][controller_username].num_screen;

        let stringTableString = JSON.stringify(string_table);
        let language = this.props.receiver.lang;
        let preferences_id = controller_mac_addr + "_" + controller_username + "_uniview";

        if (username != '' && password != '') {
            window.cordova.exec(function (result) {
                //Update Success
                window.app.hideLoading();
                //  console.log("Uniview retrieve camera success")
                if (result.substring(result.length - 1, result.length) == ',') result = result.substring(0, result.length - 1);// Remove the last comma
                sessionStorage.setItem('devices', result);

                if (num_screen != null) window.cordova.exec(function () { }, function () { }, "UniviewCameraPlugin", "accessDevice", [result, num_screen, language, stringTableString, preferences_id]);
                else window.cordova.exec(function () { }, function () { }, "UniviewCameraPlugin", "accessDevice", [result, 2, language, stringTableString, preferences_id]);

            }, this.univiewLoginFailed, "UniviewCameraPlugin", "loginAccount", [username, password]);
        } else {
            window.app.showToast(this.getString('uniview_not_logged_in'), 3000);
        }
    }

    univiewLoginFailed = () => {
        window.app.hideLoading();
        // console.log("Uniview retrieve camera failed")
        window.app.showToast(this.getString('login_failed'), 3000);
    }

    handleDLink = () => {
        window.app.showLoading();
        // console.log("DLink retrieve updated cameras now")

        let dlinkcameras = JSON.parse(window.localStorage.getItem('dlinkcameras'));

        let controller_info = {}
        if (this.props.receiver.active_controller != null) {
            controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
        }
        let controller_mac_addr = controller_info.mac_addr;
        let controller_username = controller_info.username;
        let cameras = dlinkcameras[controller_mac_addr][controller_username].cameras;
        let str = "";
        for (var index = 0; index < cameras.length; index++) {
            if (cameras[index].deviceType == 5 || cameras[index].deviceType == 10) { //for each nvr add into the list
                this.indexToAdd = index;
                str = str.concat("Serial No:" + cameras[index].serialNo + "\n");
                str = str.concat("Username:" + cameras[index].username + "\n");
                str = str.concat("Password:" + cameras[index].password + "\n");
                str = str.concat("DeviceType:"+ cameras[index].deviceType + "\n");
                str = str.concat("Index:" + index + "\n");
                str = str.concat(",");
            }
        }

        if (str.length == 0) { //if there are no NVRs
            window.app.hideLoading();
            this.accessLiveScreen();
        } else {
            window.cordova.exec(this.updateSuccess, function () {
                //Failed
            }, "DLinkCameraPlugin", "updateAllNVRs", [str]);
        }
    }

    updateSuccess = (result) => {
        window.app.hideLoading();

        let dlinkcameras = JSON.parse(window.localStorage.getItem('dlinkcameras'));
        // When app first started, active_controller is null, app will crash if we try to get the name
        let controller_info = {}
        if (this.props.receiver.active_controller != null) {
            controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
        }
        let controller_mac_addr = controller_info.mac_addr;
        let controller_username = controller_info.username;
        let cameras = dlinkcameras[controller_mac_addr][controller_username].cameras;

        let nvrs = result.split('@'); //array of nvrs
        for (let i in nvrs) {
            let camera = (nvrs[i]).split(',');
            let index_of_arr = -1;
            let temp_devices = [];
            for (let j in camera) {
                if (j == 0) {
                    index_of_arr = parseInt(camera[j]);
                } else {
                    let temp_device = {};
                    temp_device.channel_id = camera[j].substring(camera[j].indexOf('channel_id:') + 11, camera[j].indexOf('\n'));
                    if (temp_device.channel_id != '') camera[j] = camera[j].substring(camera[j].indexOf('\n') + 1, camera[j].length);
                    temp_device.camera_name = camera[j].substring(camera[j].indexOf('camera_name:') + 12, camera[j].indexOf('\n'));
                    temp_device.deviceType = 1;
                    // Check if the channel has any device connected to it
                    // If yes add to the list of devices
                    if (temp_device.camera_name.length > 0) {
                        temp_devices.push({ serialNo: '', username: '', password: '', deviceName: temp_device.camera_name, deviceType: temp_device.deviceType, cameras: [], channelNumber: temp_device.channel_id });
                    }
                }
            }

            //if there are at least 1 camera connected to the nvr
            if (temp_devices.length > 0) {
                cameras[index_of_arr].cameras = temp_devices;
                dlinkcameras[controller_mac_addr][controller_username].cameras = cameras;
                window.localStorage.setItem('dlinkcameras', JSON.stringify(dlinkcameras));
            }
        }

        // console.log("NVR update success")
        this.accessLiveScreen();
    }

    accessLiveScreen = () => {
        let stringTableString = JSON.stringify(string_table);
        let language = this.props.receiver.lang;
        var str = "";

        let dlinkcameras = JSON.parse(window.localStorage.getItem('dlinkcameras'));
        let controller_info = {}
        if (this.props.receiver.active_controller != null) {
            controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
        }
        let controller_mac_addr = controller_info.mac_addr;
        let controller_username = controller_info.username;
        let cameras = dlinkcameras[controller_mac_addr][controller_username].cameras;
        let num_screen = dlinkcameras[controller_mac_addr][controller_username].num_screen;
        let preferences_id = controller_mac_addr + "_" + controller_username + "_dlink";

        for (var i = 0; i < cameras.length; i++) {
            //  If the device is an NVR
            if (cameras[i].deviceType == 5 || cameras[i].deviceType == 10) {
                var nvrCameras = cameras[i].cameras;
                for (var j = 0; j < nvrCameras.length; j++) {
                    str = str.concat("Serial No:" + cameras[i].serialNo + "-" + j + "\n");
                    str = str.concat("Username:" + cameras[i].username + "\n");
                    str = str.concat("Password:" + cameras[i].password + "\n");
                    str = str.concat("CameraName:" + nvrCameras[j].deviceName + "\n");
                    str = str.concat("DeviceType:" + nvrCameras[j].deviceType + "\n");
                    str = str.concat("ChannelNumber:" + nvrCameras[j].channelNumber + "\n");
                    str = str.concat(",");
                }
            }
            //  If the device is not an NVR
            else {
                str = str.concat("Serial No:" + cameras[i].serialNo + "\n");
                str = str.concat("Username:" + cameras[i].username + "\n");
                str = str.concat("Password:" + cameras[i].password + "\n");
                str = str.concat("CameraName:" + cameras[i].deviceName + "\n");
                str = str.concat("DeviceType:" + cameras[i].deviceType + "\n");
                str = str.concat("ChannelNumber:" + cameras[i].channelNumber + "\n");
                str = str.concat(",");
            }
        }

        window.cordova.exec(function () {
            //Success
        }, function () {
            //Failed
        }, "DLinkCameraPlugin", "accessLiveScreenView", [str, num_screen, language, stringTableString, preferences_id]);
    }

    togglePopup() {
        this.setState({
            show_popup: !this.state.show_popup
        })
    }

    handleShouldShowPopUp = () => {
        // Kaiwei 20210504 when app first started, active_controller is null, app will crash if we try to get the name
        let controller_info = {}
        if (this.props.receiver.active_controller != null) {
            controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
        }
        let controller_mac_addr = controller_info.mac_addr;
        let controller_username = controller_info.username;

        let dlink_has_cameras = false;
        let uniview_has_settings = false;

        let dlinkcameras = JSON.parse(window.localStorage.getItem('dlinkcameras'));
        if (dlinkcameras != null) {
            if (dlinkcameras[controller_mac_addr] != null) {
                if (dlinkcameras[controller_mac_addr][controller_username] != null) {
                    if (dlinkcameras[controller_mac_addr][controller_username].cameras != null) {
                        if (dlinkcameras[controller_mac_addr][controller_username].cameras.length > 0) {
                            dlink_has_cameras = true;
                        }
                    }
                }
            }
        }

        //Check if uniview settings is set
        let uniview_info = JSON.parse(window.localStorage.getItem('uniview_info'));
        if (uniview_info != null) {
            if (uniview_info[controller_mac_addr] != null) {
                if (uniview_info[controller_mac_addr][controller_username] != null) {
                    if (uniview_info[controller_mac_addr][controller_username].username != ""
                        && uniview_info[controller_mac_addr][controller_username].password != ""
                    ) {
                        uniview_has_settings = true;
                    }

                }
            }
        }

        //If both conditions are met, display pop up
        if (dlink_has_cameras && uniview_has_settings) {
            this.setState({
                should_show_popup: true,
                show_popup: !this.state.show_popup
            })
        } else if (dlink_has_cameras) {
            this.handleDLink();
        } else if (uniview_has_settings) {
            this.handleUniview();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.tag !== this.state.tag) {
            if (nextProps.tag == 'Dashboard' || nextProps.tag == 'MSM') {
                this.setState({
                    is_dashboard_active: true, //active
                    is_group_active: false,
                    is_scenes_active: false,
                    is_report_active: false,
                    is_system_active: false,
                    is_ipcam_active: false,
                    is_layout_active: false,
                    is_guest_room_active: false,
                    is_rt_energy_active: false,
                    is_iaq_mon_active: false,
                    tag: nextProps.tag
                })
            } else if (nextProps.tag == "Groups" || nextProps.tag == "Group_Details") {
                this.setState({
                    is_dashboard_active: false,
                    is_group_active: true, //active
                    is_scenes_active: false,
                    is_report_active: false,
                    is_system_active: false,
                    is_ipcam_active: false,
                    is_layout_active: false,
                    is_guest_room_active: false,
                    is_rt_energy_active: false,
                    is_iaq_mon_active: false,
                    tag: nextProps.tag
                })
            } else if (nextProps.tag == "Scenes") {
                this.setState({
                    is_dashboard_active: false,
                    is_group_active: false,
                    is_scenes_active: true, //active
                    is_report_active: false,
                    is_system_active: false,
                    is_ipcam_active: false,
                    is_layout_active: false,
                    is_guest_room_active: false,
                    is_rt_energy_active: false,
                    is_iaq_mon_active: false,
                    tag: nextProps.tag
                })
            } else if (nextProps.tag == "Reports") {
                this.setState({
                    is_dashboard_active: false,
                    is_group_active: false,
                    is_scenes_active: false,
                    is_report_active: true, //active
                    is_system_active: false,
                    is_ipcam_active: false,
                    is_layout_active: false,
                    is_guest_room_active: false,
                    is_rt_energy_active: false,
                    is_iaq_mon_active: false,
                    tag: nextProps.tag
                })
            } else if (nextProps.tag == "System") {
                this.setState({
                    is_dashboard_active: false,
                    is_group_active: false,
                    is_scenes_active: false,
                    is_report_active: false,
                    is_system_active: true, //active
                    is_ipcam_active: false,
                    is_layout_active: false,
                    is_guest_room_active: false,
                    is_rt_energy_active: false,
                    is_iaq_mon_active: false,
                    tag: nextProps.tag
                })
            }
            else if (nextProps.tag == "Ipcam") {
                this.setState({
                    is_dashboard_active: false,
                    is_group_active: false,
                    is_scenes_active: false,
                    is_report_active: false,
                    is_system_active: false,
                    is_ipcam_active: true, //active
                    is_layout_active: false,
                    is_guest_room_active: false,
                    is_rt_energy_active: false,
                    is_iaq_mon_active: false,
                    tag: nextProps.tag
                })
            } else if (nextProps.tag == "Layout") {
                this.setState({
                    is_dashboard_active: false,
                    is_group_active: false,
                    is_scenes_active: false,
                    is_report_active: false,
                    is_system_active: false,
                    is_ipcam_active: false,
                    is_layout_active: true, //active
                    is_guest_room_active: false,
                    is_rt_energy_active: false,
                    is_iaq_mon_active: false,
                    tag: nextProps.tag
                })
            } else if (nextProps.tag == "Guest_Room_Overview") {
                this.setState({
                    is_dashboard_active: false,
                    is_group_active: false,
                    is_scenes_active: false,
                    is_report_active: false,
                    is_system_active: false,
                    is_ipcam_active: false,
                    is_layout_active: false,
                    is_guest_room_active: true, //active
                    is_rt_energy_active: false,
                    is_iaq_mon_active: false,
                    tag: nextProps.tag
                })
            } else if (nextProps.tag == "RT_Energy_View") {
                this.setState({
                    is_dashboard_active: false,
                    is_group_active: false,
                    is_scenes_active: false,
                    is_report_active: false,
                    is_system_active: false,
                    is_ipcam_active: false,
                    is_layout_active: false,
                    is_guest_room_active: false,
                    is_rt_energy_active: true, //active
                    is_iaq_mon_active: false,
                    tag: nextProps.tag
                })
            } else if (nextProps.tag == "IAQ_Monitoring") {
                this.setState({
                    is_dashboard_active: false,
                    is_group_active: false,
                    is_scenes_active: false,
                    is_report_active: false,
                    is_system_active: false,
                    is_ipcam_active: false,
                    is_layout_active: false,
                    is_guest_room_active: false,
                    is_rt_energy_active: false,
                    is_iaq_mon_active: true, //active
                    tag: nextProps.tag
                })
            }
        }

        return true;
    }

    render() {
        let controller_info = {}
        if (this.props.receiver.active_controller != null) {
            controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
        }
        let controller_mac_addr = controller_info.mac_addr;
        let controller_username = controller_info.username;

        let available_functions = {};
        let is_display_ipcam = false;
        let dlink_has_cameras = false;
        let uniview_has_settings = false;
        let is_display_report = false;
        let is_display_layout = false;
        let is_display_guest_rooms = false;
        let is_display_groups = false;
        let is_display_scenes = false;
        let is_display_rt_energy = false;
        let is_display_iaq_mon = false;

        if (this.props.receiver.active_controller != null) {
            if (this.props.receiver.active_controller.available_functions != null) {
                available_functions = this.props.receiver.active_controller.available_functions;
                if (available_functions.ipcam) {
                    //Check if there is at least 1 dlink camera
                    let dlinkcameras = JSON.parse(window.localStorage.getItem('dlinkcameras'));
                    if (dlinkcameras != null) {
                        if (dlinkcameras[controller_mac_addr] != null) {
                            if (dlinkcameras[controller_mac_addr][controller_username] != null) {
                                if (dlinkcameras[controller_mac_addr][controller_username].cameras != null) {
                                    if (dlinkcameras[controller_mac_addr][controller_username].cameras.length > 0) {
                                        dlink_has_cameras = true;
                                    }
                                }
                            }
                        }
                    }

                    //Check if uniview settings is set
                    let uniview_info = JSON.parse(window.localStorage.getItem('uniview_info'));
                    if (uniview_info != null) {
                        if (uniview_info[controller_mac_addr] != null) {
                            if (uniview_info[controller_mac_addr][controller_username] != null) {
                                if (uniview_info[controller_mac_addr][controller_username].username != ""
                                    && uniview_info[controller_mac_addr][controller_username].password != ""
                                ) uniview_has_settings = true;
                            }
                        }
                    }

                    // Only display IP camera feature when it is mobile version
                    if ((uniview_has_settings == true || dlink_has_cameras == true) && this.props.receiver.is_mobile) {
                        is_display_ipcam = true;
                    }
                }

                // show report button if any one of these is true;
                is_display_report = available_functions.trend_graph || available_functions.energy_graph
                    || available_functions.op_report || available_functions.err_report || available_functions.ppd
                    || available_functions.ppd_billing || available_functions.rt_energy;

                // Standard user cannot access Reports
                if (this.props.receiver.active_controller.user_class != 'Admin') is_display_report = false;


                is_display_layout = available_functions.layout && this.props.receiver.app_model == 'F'
                    && !this.props.receiver.is_mobile;

                is_display_guest_rooms = available_functions.unit_manage && this.props.receiver.app_model == 'F';

                is_display_groups = available_functions.group && !window.app.state.is_msm_mode;
                is_display_scenes = available_functions.scene && !window.app.state.is_msm_mode;

                let rtEnerygLayout = false;

                if (available_functions.hasOwnProperty('rt_layout')) {
                    if (available_functions.rt_layout) rtEnerygLayout = available_functions.rt_layout;  //if false or null or does not exist, will not set.
                }

                is_display_rt_energy = rtEnerygLayout && this.props.receiver.app_model == 'F' && !this.props.receiver.is_mobile;


                let iaqMonitoring = false;

                if (available_functions.hasOwnProperty('iaq_mon')) {
                    if (available_functions.iaq_mon) iaqMonitoring = available_functions.iaq_mon;  //if false or null or does not exist, will not set.
                }

                is_display_iaq_mon = iaqMonitoring; // && this.props.receiver.app_model == 'F' && !this.props.receiver.is_mobile;
            }
        }

        if (this.props.receiver.active_controller != null) {
            if (this.props.receiver.active_controller.model == 'L01' || this.props.receiver.active_controller.model == 'R01') {
                is_display_scenes = false;
                is_display_report = false;
                is_display_layout = false;
                is_display_guest_rooms = false;
                is_display_ipcam = false;
            }
        }

        //styling for bottom menu bar
        let bottomLabelContainer = {
            background: '#00A0E4',
            color: '#FFFFFF',
            width: '100%',
            overflowX: 'auto',
            textAlign: 'center',
        }

        let bottomContainer = {
            position: 'fixed',
            bottom: '0',
            width: '100%'
        }

        let navContainer = {
            width: '100%',
            height: '55px',
            boxShadow: '0 0 3px rgba(0, 0, 0, 0.2)',
            backgroundColor: '#ffffff',
            display: 'flex',
            overflowX: 'auto',
        }

        let nav_link = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            flexGrow: 1,
            minWidth: '50px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            fontFamily: 'sans-serif',
            fontSize: '13px',
            color: '#595f61',
            textDecoration: 'none',
            transition: 'backgroundColor 0.1s ease-in-out',
        }

        let nav_link_active = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            flexGrow: 1,
            minWidth: '50px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            fontFamily: 'sans-serif',
            fontSize: '13px',
            textDecoration: 'none',
            transition: 'backgroundColor 0.1s ease-in-out',
            color: '#00A0E4'
        }

        let ipcam_link = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            flexGrow: 1,
            minWidth: '50px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            fontFamily: 'sans-serif',
            fontSize: '13px',
            color: '#595f61',
            textDecoration: 'none',
            transition: 'backgroundColor 0.1s ease-in-out',
        }

        let hidden = {
            display: 'none'
        }

        let icon_width = 24;

        return (
            <div style={bottomContainer} id='bottom_menu_bar'>
                <nav style={navContainer}>
                    <a href="#" style={this.state.is_dashboard_active ? nav_link_active : nav_link} onClick={() => navigateDashboard("null")}>
                        <img src={dashboard_icon} alt='dashboard_icon' style={{ opacity: this.state.is_dashboard_active ? 1 : 0.5, width: icon_width, maxWidth: 32, marginBottom: 5 }} />
                        <span>{this.props.receiver.getString('dashboard')}</span>
                    </a>
                    <a href="#" style={!is_display_layout ? hidden : this.state.is_layout_active ? nav_link_active : nav_link} onClick={() => navigateLayout("null")}>
                        <img src={layout_icon} alt='layout_icon' style={{ opacity: this.state.is_layout_active ? 1 : 0.5, width: icon_width, maxWidth: 32, marginBottom: 5 }} />
                        <span>{this.props.receiver.getString('layout')}</span>
                    </a>

                    <a href="#" style={!is_display_rt_energy ? hidden : this.state.is_rt_energy_active ? nav_link_active : nav_link} onClick={() => navigateRTEnergy("null")}>
                        <img src={rt_energy_view_icon} alt='rt_energy_view_icon' style={{ opacity: this.state.is_rt_energy_active ? 1 : 0.5, width: icon_width, maxWidth: 32, marginBottom: 5 }} />
                        <span>{this.props.receiver.getString('rt_energy_view')}</span>
                    </a>

                    <a href="#" style={!is_display_iaq_mon ? hidden : this.state.is_iaq_mon_active ? nav_link_active : nav_link} onClick={() => navigateIAQMonitoring("null")}>
                        <img src={iaq_monitoring_icon} alt='iaq_monitoring_icon' style={{ opacity: this.state.is_iaq_mon_active ? 1 : 0.5, width: icon_width, maxWidth: 32, marginBottom: 5 }} />
                        <span>{this.props.receiver.getString('IAQ')}</span>
                    </a>

                    <a href="#" style={!is_display_guest_rooms ? hidden : this.state.is_guest_room_active ? nav_link_active : nav_link} onClick={() => navigateGuestRoom("null")}>
                        <img src={guest_room_icon} alt='guest_room_icon' style={{ opacity: this.state.is_guest_room_active ? 1 : 0.5, width: icon_width, maxWidth: 32, marginBottom: 5 }} />
                        <span>{this.props.receiver.getString('guest_rooms')}</span>
                    </a>
                    <a href="#" style={!is_display_groups ? hidden : this.state.is_group_active ? nav_link_active : nav_link} onClick={() => navigateGroups("null")} >
                        <img src={group_icon} alt='group_icon' style={{ opacity: this.state.is_group_active ? 1 : 0.5, width: icon_width, maxWidth: 32, marginBottom: 5 }} />
                        <span>{this.props.receiver.getString('group')}</span>
                    </a>
                    <a href="#" style={!is_display_scenes ? hidden : this.state.is_scenes_active ? nav_link_active : nav_link} onClick={() => navigateScenes("null")} >
                        <img src={scene_icon} alt='scene_icon' style={{ opacity: this.state.is_scenes_active ? 1 : 0.5, width: icon_width, maxWidth: 32, marginBottom: 5 }} />
                        <span>{this.props.receiver.getString('scene')}</span>
                    </a>

                    <a href="#" style={!is_display_report ? hidden : this.state.is_report_active ? nav_link_active : nav_link} onClick={() => navigateReport("null")}>
                        <img src={report_icon} alt='report_icon' style={{ opacity: this.state.is_report_active ? 1 : 0.5, width: icon_width, maxWidth: 32, marginBottom: 5 }} />
                        <span>{this.props.receiver.getString('report')}</span>
                    </a>

                    <a href="#" style={is_display_ipcam ? ipcam_link : hidden} onClick={this.handleShouldShowPopUp}>
                        <img src={ipcam_icon} alt='ipcam_icon' style={{ opacity: this.state.is_ipcam_active ? 1 : 0.5, width: icon_width, maxWidth: 32, marginBottom: 5 }} />
                        <span>{this.props.receiver.getString('ipcam')}</span>
                    </a>
                    {this.state.show_popup ?
                        <Popup text="Click close button"
                            handleUniview={this.handleUniview}
                            univiewTitle={this.props.receiver.getString('uniview')}
                            handleDLink={this.handleDLink}
                            dlinkTitle={this.props.receiver.getString('dlink')}
                            closePopup={this.togglePopup.bind(this)} />
                        : null}
                    <a href="#" style={this.state.is_system_active ? nav_link_active : nav_link} onClick={() => navigateSystem("null")}>
                        <img src={system_icon} alt='system_icon' style={{ opacity: this.state.is_system_active ? 1 : 0.5, width: icon_width, maxWidth: 32, marginBottom: 5 }} />
                        <span>{this.props.receiver.getString('sys')}</span>
                    </a>
                </nav>
            </div>
        )

    }
}